{
  "activity_count": 12,
  "bills_count": 3,
  "bills_summary": "• 2026-05-12: Mortgage — $3,210\n• 2026-05-14: Verizon Fios — $95\n• 2026-05-15: ConEd electric — $182",
  "display_name": "Andre",
  "household_name": "Andre's household",
  "last_login_label": "April 23, 2026 (16 days ago)",
  "sign_in_url": "https://dev.hearthfire.ai/sign-in?next=/fire"
}
